// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { IconDelete } from 'components/atoms/icons/IconDelete';
import { IconEdit } from 'components/atoms/icons/IconEdit';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { COLLECT_ROUTE_MATERIAL_COLOR_PALETTE } from 'util/constants/colorPalette';
import { CollectRoute } from 'types/routeManagementTypes';
import { normalizeNumber } from 'util/commons';
import Popover from 'components/atoms/Popover';

interface RouteItemProps {
  route: CollectRoute;
  isActive?: boolean;
  onClick: () => void;
  onDelete: (routeId: number, routeName: string) => void;
  onEdit: () => void;
}

const RouteItem = ({
  route,
  isActive = false,
  onClick,
  onDelete,
  onEdit,
}: RouteItemProps) => {
  const { t } = useTranslation();

  const colorIndexes = route.collectRouteMaterials.map((material) =>
    route.acceptanceMaterial.indexOf(material)
  );

  return (
    <div
      className={`${styles.routeItem} ${isActive ? styles.active : ''}`}
      onClick={onClick}
    >
      <div className={styles.topRow}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <Popover
            content={route.routeName}
            autoGen={{
              lines: 1,
              odd: 4,
            }}
            positions={['top']}
            containerStyle={{
              maxWidth: '300px',
              wordBreak: 'break-all',
            }}
          >
            <div className={styles.siteName}>{route.routeName}</div>
          </Popover>
        </div>
        <div className={styles.actions}>
          <IconEdit stroke="#e7e7e7" onClick={onEdit} />
          <IconDelete
            stroke="#e7e7e7"
            onClick={(e) => {
              e.stopPropagation();
              onDelete(route.id, route.routeName);
            }}
          />
        </div>
      </div>
      <div className={styles.bottomRow}>
        <div className={styles.numberOfSite}>
          {normalizeNumber({
            value: route.emitSitesCount,
          })}
          {route.emitSitesCount === 1
            ? t('route_settings.site')
            : t('route_settings.sites')}
        </div>
        <div className={styles.materials}>
          {colorIndexes.slice(0, 6).map((index, i) => (
            <div
              key={i}
              className={styles.material}
              style={{
                backgroundColor:
                  COLLECT_ROUTE_MATERIAL_COLOR_PALETTE[
                    index % COLLECT_ROUTE_MATERIAL_COLOR_PALETTE.length
                  ],
              }}
            ></div>
          ))}
          {colorIndexes.length > 6 && (
            <div className={styles.moreCount}>+{colorIndexes.length - 6}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RouteItem;
